'use client';

import React from 'react';
import { usePathname } from 'next/navigation';

export default function GlobalMeta() {
    const pathname = usePathname();

    // Skip meta tag on "/thailand-tour" path
    if (pathname === '/thailand-tour') {
        return null;
    }

    return (
        <>
            <meta name="robots" content="noindex, nofollow" />
        </>
    );
}
